<template>
  <div>
    <p class="lead text-center font-medium-3 mt-1">General Information</p>
    <table class="table text-capitalize transparent">
      <tr>
        <th>{{ $t("pbx_call.caller") }}</th>
        <td>{{ resolverCallRol(data.data.devices, "caller") }}</td>
      </tr>
      <tr>
        <th>{{ $t("pbx_call.receiver") }}</th>
        <td>{{ resolverCallRol(data.data.devices, "receiver") }}</td>
      </tr>
      <tr>
        <th>{{ $t("pbx_call.recording") }}</th>
        <td>
          <audio
            controls
            v-if="data.data.recording_url"
            :controlsList="$can('download', 'PbxCall') ? 'download' : 'nodownload'"
          >
            <source :src="data.data.recording_url" />
            Your browser does not support the audio element.
          </audio>
        </td>
      </tr>
      <tr>
        <th>User Agent</th>
        <td>{{ data.data.logs.user_agent }}</td>
      </tr>
      <tr>
        <th>Caller IP</th>
        <td>{{ data.data.logs.caller_ip }}</td>
      </tr>
      <tr>
        <th>Status</th>
        <td>{{ data.data.status }}</td>
      </tr>
      <tr v-if="data.data.status == 'HANGUP'">
        <th>Hangup Cause</th>
        <td>{{ data.data.logs.hangup_cause }}</td>
      </tr>
      <tr>
        <th>{{ $t("pbx_call.started_at") }}</th>
        <td>{{ formatDateAssigned(data.data.started_at) }}</td>
      </tr>
      <tr>
        <th>Aswered time</th>
        <td>{{ formatDateAssigned(data.data.answered_time) }}</td>
      </tr>
      <tr>
        <th>{{ $t("pbx_call.ended_at") }}</th>
        <td>{{ formatDateAssigned(data.data.ended_at) }}</td>
      </tr>
      <tr>
        <th>{{ $t("date.created_at") }}</th>
        <td>{{ formatDateAssigned(data.data.created_at) }}</td>
      </tr>
      <tr>
        <th>{{ $t("date.updated_at") }}</th>
        <td>{{ formatDateAssigned(data.data.updated_at) }}</td>
      </tr>
    </table>

    <div class="w-100" style="height: 1px; background: white"></div>

    <div v-if="Object.keys(data.data.logs).length > 0">
      <p class="lead text-center font-medium-3 mt-1">Logs</p>
      <div v-for="event in data.data.logs.events">
        <p class="lead font-medium-2 mt-1 text-lowercase">
          {{ event.name }}
          <span class="float-right font-medium-1">{{ formatDateAssigned(event.timestamp) }}</span>
        </p>
        <table class="table text-capitalize transparent">
          <tr>
            <th>Call state</th>
            <td>{{ event.details.channel_call_state }}</td>
          </tr>
          <tr>
            <th>User Agent</th>
            <td>{{ event.user_agent }}</td>
          </tr>
          <tr>
            <th>DMFT Digit</th>
            <td>{{ event.details.dmft_digit }}</td>
          </tr>
          <tr>
            <th></th>
            <th>Origin</th>
            <th>Destionation</th>
          </tr>
          <tr>
            <th>Number</th>
            <td>{{ event.details.caller_orig_number }}</td>
            <td>{{ event.details.caller_dest_number }}</td>
          </tr>
          <tr>
            <th>Codec</th>
            <td>{{ event.details.channel_read_codec_name }}</td>
            <td>{{ event.details.channel_write_codec_name }}</td>
          </tr>
          <tr>
            <th>Rate</th>
            <td>{{ event.details.channel_read_codec_rate }}</td>
            <td>{{ event.details.channel_write_codec_rate }}</td>
          </tr>
          <tr>
            <th>Bitrate</th>
            <td>{{ event.details.channel_read_codec_bit_rate }}</td>
            <td>{{ event.details.channel_write_codec_bit_rate }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  props: {
    data: Object,
  },
  setup(props) {
    const formatDateAssigned = (value) => {
      return moment(value).format("DD/MM/YYYY HH:mm:ss");
    };

    const resolverCallRol = (devices, rol) => {
      let caller = "";
      devices.forEach((element) => {
        if (element.call_device.rol === rol) {
          caller = element.extension;
        }
      });
      return caller;
    };

    return {
      formatDateAssigned,
      resolverCallRol,
    };
  },
};
</script>

<style scoped>
.transparent {
  background-color: transparent !important;
}
</style>
